import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import heroSectionBg from "../../images/v4/aiFeatures/aiKnowledgeBase/images/heroSectionBg.png";
import cardBg1 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/cardBg1.png";
import cardBg2 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/cardBg2.png";
import cardImg1 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/cardImg1.webp";
import cardImg2 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/cardImg2.webp";
import detailImg2 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/detailImg2.webp";
import industryAdaptBg from "../../images/v4/aiFeatures/aiKnowledgeBase/images/industryAdaptBg.png";
import benefitSectionBg from "../../images/v4/aiFeatures/aiKnowledgeBase/images/benefitSectionBg.png";
import tabsSectionBg from "../../images/v4/aiFeatures/aiKnowledgeBase/images/tabsSectionBg.png";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";

import heroIcon1 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/heroIcon1.svg";
import heroIcon2 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/heroIcon2.svg";
import heroIcon3 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/heroIcon3.svg";
import aiIcon from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/aiIcon.svg";
import aiIcon2 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/aiIcon2.svg";

import cardTabImg1 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/cardTabImg1.webp";
import cardTabImg2 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/cardTabImg2.webp";
import cardTabImg3 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/cardTabImg3.webp";
import cardTabImg4 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/cardTabImg4.webp";

import adaptImg1 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/adaptImg1.svg";
import adaptImg2 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/adaptImg2.svg";
import adaptImg3 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/adaptImg3.svg";
import adaptImg4 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/adaptImg4.svg";
import adaptImg5 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/adaptImg5.svg";

import benefitIcon1 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/benefitIcon1.svg";
import benefitIcon2 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/benefitIcon2.svg";
import benefitIcon3 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/benefitIcon3.svg";
import benefitIcon4 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/benefitIcon4.svg";
import benefitIcon5 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/benefitIcon5.svg";
import benefitIcon6 from "../../images/v4/aiFeatures/aiKnowledgeBase/icons/benefitIcon6.svg";

import realWorldImg1 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/realWorldImg1.webp";
import realWorldImg2 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/realWorldImg2.webp";
import realWorldImg3 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/realWorldImg3.webp";
import realWorldImg4 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/realWorldImg4.webp";

const useStyles = makeStyles((theme) => ({
  commonHeroSection: {
    backgroundImage: `url(${heroSectionBg})`,
    backgroundPosition: "bottom",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    position: "relative",
  },
  heroSection: {
    paddingTop: "120px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "0",
      paddingBottom: "0",
    },
  },
  boxes: {
    marginTop: "56px",
    width: "100%",
    display: "flex",
    gap: "24px",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "20px",
      flexDirection: "column",
      gap: "12px",
    },
  },
  box: {
    gap: "16px",
    width: "25%",
    padding: "24px",
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(50px)",
    "&:first-child": {
      background: "linear-gradient(105deg, #431469 0%, #8C48C3 100%)",
    },
    "&:nth-child(2)": {
      background: "linear-gradient(90deg, #074545 0%, #009F9E 100%)",
    },
    "&:last-child": {
      background: "linear-gradient(105deg, #0A2F4F 0%, #2576BB 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      flex: "1",
      width: "100%",
      padding: "10px",
      justifyContent: "center",
      alignItems: "center",
      gap: "20px",
    },
  },
  heroSectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    gap: "24px",
    textAlign: "center",
    "& span": {
      background: "linear-gradient(93deg, #058ED6 4.84%, #00BFA5 99.8%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      display: "inline-flex",
      alignItems: "baseline",
      justifyContent: "flex-start",
      gap: "5px",
      "& img": {
          marginRight:'10px',
        },
      "@media only screen and (max-width: 600px)": {
        "& img": {
          height: "30px",
          width: "30px",
          marginRight:'14px'
        },
      },
    },
  },
  partnerSlide: {
    width: "144px !important",
    "& img": {
      width: "144px",
      filter: "brightness(1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "max-content !important",
      "& img": {
        width: "100px",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 60px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  trustedSection: {
    "& .trustedHeading": {
      textAlign: "center",
    },
  },
  cardsSection: {
    background: "#021D1D",
    "& .header": {
      display: "flex",
      marginBottom: "64px",
      width: "100%",
      gap: "32px",
      flexDirection: "column",
      "& h2": {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "5px",
      },
      "& p": {
        width: "80%",
      },
      "@media only screen and (max-width: 600px)": {
        marginBottom: "40px",
      },
    },
    "& .cardImg": {
      "& img": {
        width: "100%",
        height: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .cardImg": {
        width: "100%",
        height: "100%",
        marginBottom: "15px",
        marginTop: "0",
        "& img": {
          width: "100%",
          height: "100%",
        },
      },
    },
  },
  hoverCardSection: {
    background: "linear-gradient(180deg, #021D1D 0%, #011C33 100%)",
    "& .header": {
      display: "flex",
      marginBottom: "64px",
      width: "100%",
      gap: "32px",
      flexDirection: "column",
      "& h2": {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "5px",
      },
      "& p": {
        width: "80%",
      },
      "@media only screen and (max-width: 600px)": {
        marginBottom: "40px",
      },
    },
  },
  hoverCardContianer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    gap: "30px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
    },
  },

  hoverCard: {
    background:
      "linear-gradient(105deg, rgba(10, 47, 79, 0.35) 0%, rgba(37, 118, 187, 1) 100%)",
    padding: "16px 24px",
    width: "32%",
    gap: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderRadius: "12px",
    opacity: "0.5",
    transition: "0.3s ease",
    cursor: "pointer",
    textAlign: "left",
    transform: "scale(1)",
    "&:hover": {
      transform: "scale(1.1)",
      opacity: "1",
      // padding: '28px 24px',
      background: "linear-gradient(105deg, #0A2F4F 0%, #2576BB 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      opacity: "1",
      "&:hover": {
        transform: "scale(1)",
      },
    },
  },

  cardsSection: {
    background: "#021D1D",
    "& .header" :{
      marginBottom: "64px",
      "@media only screen and (max-width: 600px)": {
        marginBottom: "40px",
      }
    },
    "& .cardImg": {
      "& img": {
        width: "100%",
        height: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .cardImg": {
        width: "100%",
        height: "100%",
        marginBottom: "15px",
        marginTop: "0",
        "& img": {
          width: "100%",
          height: "100%",
        },
      },
    },
  },
  belowText: {
    width: "100%",
    textAlign: "right",
    color: "#6691b7",
    marginTop: "20px",
  },
  cardTabsSection: {
    background: "linear-gradient(180deg, #011C33 0%, #210538 100%)",
    "& .header": {
      display: "flex",
      flexDirection: "column",
      marginBottom: "64px",
      gap: "32px",
      width: "100%",
      "& p": {
        width: "70%",
      },
      "& span": {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "5px",
        "@media only screen and (max-width: 600px)": {
          "& img": {
            height: "30px",
            width: "30px",
          },
        },
      },
    },
  },
  cardTabsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    width: "100%",
  },
  cardTabsSelectors: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    gap: "30px",
    "@media only screen and (max-width: 600px)": {
      overflow: "auto",
      gap: "15px",
      justifyContent: "flex-start",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  cardTabsSelector: {
    background: "rgba(255, 255, 255, 0.10)",
    padding: "24px",
    width: "32%",
    borderRadius: "16px",
    color: "#fff",
    opacity: "0.5",
    transition: "0.3s ease",
    border: "2px solid transparent",
    cursor: "pointer",
    textAlign: "center",
    "&.active": {
      opacity: "1",
      background:
        "linear-gradient(105deg, rgba(77, 0, 140, 0.50) 0%, rgba(181, 93, 251, 0.50) 100%)",
      border: "2px solid rgba(255, 255, 255, 0.50)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "max-content",
      minWidth: "max-content",
      padding: "12px 8px",
      borderWidth: "1px",
      borderRadius: "6px",
      "&.active": {
        borderWidth: "1px",
      },
    },
  },
  cardTab: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "24px 64px",
    borderRadius: "12px",
    background:
      "linear-gradient(105deg, rgba(77, 0, 140, 0.50) 0%, rgba(181, 93, 251, 0.50) 100%)",
    "@media only screen and (max-width: 600px)": {
      padding: "20px",
      flexDirection: "column",
    },
  },
  cardTabLeft: {
    width: "30%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  cardTabRight: {
    width: "65%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  detailSection: {
    background: "linear-gradient(180deg, #210538 0%, #104F4F 100%)",
  },
  detailCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  detailCardLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "38%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "&.card2": {
        width: "100%",
      },
    },
  },
  detailCardRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "48%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  salesCrmCarousel: {
    backgroundImage: `url(${industryAdaptBg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "65px",
    "& .header-section": {
      flexDirection: "column",
      width: "55%",
      "& h2": {
        marginBottom: "32px",
      },
      "& p": {
        marginBottom: "0",
      },
      "@media(max-width:768px)": {
        width: "100%",
        "& h2": {
          marginBottom: "20px",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "60px",
      "& .header": {
        width: "60%",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "50px",
      "& .header": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px",
      "& .header": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingBottom: "30px",
    },
  },
  adaptSlider: {
    padding: "15px 0!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "15px 4rem 50px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "15px 2rem 40px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "15px 10px 30px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  adaptsBox: {
    gap: "24px",
    display: "flex!important",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    height: "auto!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "20px",
      maxWidth: "350px",
      gap: "14px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "18px",
      maxWidth: "320px",
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      maxWidth: "85%",
      gap: "10px",
    },
  },
  adaptDescription: {
    gap: "10px",
    minHeight: "80px",
    "@media only screen and (max-width: 1024px)": {
      minHeight: "70px",
    },
    "@media only screen and (max-width: 768px)": {
      minHeight: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      alignItems: "baseline",
      minHeight: "auto",
    },
    "@media only screen and (max-width: 480px)": {
      minHeight: "auto",
    },
  },
  adaptBoxImg: {
    width: "48px",
    maxWidth: "48px",
    position: "relative",
    bottom: "0",
    marginBottom: "24px",
    "@media only screen and (max-width: 1024px)": {
      width: "44px",
      maxWidth: "44px",
      marginBottom: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "40px",
      maxWidth: "40px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "36px",
      maxWidth: "36px",
      marginBottom: "16px",
    },
    "@media only screen and (max-width: 480px)": {
      width: "32px",
      maxWidth: "32px",
      marginBottom: "14px",
    },
  },
  benefitSection: {
    backgroundImage: `url(${benefitSectionBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "260px",
    "& .centerContainer": {
      width: "100%",
      textAlign: "left",
      display: "flex",
      gap: "10px",
      justifyContent: "space-between",
      alignItems: "flex-start",
      margin: "0 auto",
      gap: "30px",
      "& h2": {
        width: "50%",
      },
      "& p": {
        width: "40%",
      },
      "@media (max-width:768px)": {
        flexDirection: "column",
        gap: "18px",
        marginBottom: "55px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
    "& .trustedHeading": {
      width: "80%",
      textAlign: "center",
      margin: "0 auto",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "210px",
    },
  },
  benefitContainer: {
    display: "grid",
    justifyContent: "flex-start",
    gridTemplateColumns: "repeat(3, 1fr)",
    alignItems: "stretch",
    gap: "24px",
    rowGap: "24px",
    marginTop: "60px",
    "@media only screen and (max-width: 700px)": {
        gridTemplateColumns: "repeat(2, 1fr)",
      width: "100%",
      gap: "20px",
    },
    "@media only screen and (max-width: 450px)": {
        gridTemplateColumns: "repeat(1, 1fr)",
    },
  },
  benefitBox: {
    display: "flex",
    background:
      "linear-gradient(292deg, rgba(15, 56, 91, 0.40) 0%, rgba(47, 140, 218, 0.40) 100%)",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    padding: "24px",
    borderRadius: "16px",
    transition: "0.3s ease",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "12px",
      padding: "16px",
    },
    // "&:hover": {
    //   transition: "0.3s ease",
    //   background: "linear-gradient(117deg, #F2E1FF 0.97%, #E9FFFF 100%)",
    //   "@media only screen and (max-width: 600px)": {
    //     "&:hover": {
    //       background: "transparent",
    //     },
    //   },
    // },
  },
  tabsSection: {
    backgroundImage: `url(${tabsSectionBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    position: "relative",
    paddingTop: "300px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "120px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "65px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },

  tabListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  tabListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  tabListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "-20%",
    "@media only screen and (max-width: 600px)": {
      top: "-15%",
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background:
      " linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
}));
const AiKnowledgeBaseForCrm = () => {
  const classes = useStyles();
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [cardTabSelector, setCardTabSelector] = useState(0);

  //scrollableCards
  useEffect(() => {
    const cards = document.querySelectorAll(".card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const card = entry.target;
          const currentIndex = Array.from(cards).indexOf(card);

          if (entry.isIntersecting) {
            // Remove all previous classes first
            cards.forEach((c) => {
              c.classList.remove(
                "is-previous-1",
                "is-previous-2",
                "is-previous-3",
                "is-previous-4"
              );
            });

            // Add appropriate classes based on distance from current card
            cards.forEach((c, index) => {
              if (index < currentIndex) {
                const difference = currentIndex - index;
                if (difference <= 4) {
                  // Only apply effects to 4 cards back
                  c.classList.add(`is-previous-${difference}`);
                }
              }
            });
          }
        });
      },
      {
        root: null,
        threshold: 0.5,
        rootMargin: "0px",
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);
  //scrollableCards

  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];

  const capabilities = [
    {
      heading: "Is your team wasting time without an AI knowledge base?",
      desc: "An AI-powered knowledge base helps your team quickly find the answers they need by learning from your organisation’s own documents, guides, and URLs. It delivers accurate, contextual responses instantly—right within your CRM—so there’s no need to switch tools or waste time searching. By reducing repetitive queries and internal escalations, it frees up your team to focus on meaningful tasks. You can also organise information into custom groups, making it even easier to access the right content when it’s needed most.",
      backgroundImage: cardBg1,
      img: cardImg1,
      alt: "AI knowledge base",
    },
    {
      heading: "What is Pepper Cloud’s AI knowledge base?",
      desc: "Pepper Cloud’s AI-powered knowledge base is a smart tool built into the CRM. It uses generative AI to learn from your own content—like documents, manuals, and web links. It then gives instant, helpful answers to your team during sales or support chats. This system is part of Pepper Cloud’s AI-based knowledge management and helps your team work faster, reply better, and stay consistent—all without switching between tools.",
      backgroundImage: cardBg2,
      img: cardImg2,
      alt: "AI knowledge base",
    },
  ];

  const hoverCardCard = [
    {
      heading: "35% ",
      text: " faster query resolution",
    },
    {
      heading: "24% ",
      text: "increase in customer satisfaction (CSAT)",
    },
    {
      heading: "30% ",
      text: "shorter onboarding cycles",
    },
  ];

  const cardTabs = [
    {
      tabName: "Train on your business content",
      heading: "Train on your business content",
      text: "Add your own files like product manuals, SOPs, sales decks, and links. The AI-powered knowledge base learns your content and gives clear, helpful replies.",
      image: cardTabImg1,
      alt: "AI knowledge base trained on business documents",
    },
    {
      tabName: "Create unlimited knowledge groups",
      heading: "Create unlimited knowledge groups",
      text: "Organise info into unlimited groups. Create groups like Sales, Support, or Products. This helps your team find the right answer from the right place.",
      image: cardTabImg2,
      alt: "Knowledge base organised into multiple business groups",
    },
    {
      tabName: "Smart AI-powered replies in live chat",
      heading: "Smart AI-powered replies in live chat",
      text: "Get AI-generated replies in live chat. When chatting with customers, the AI suggests smart replies based on your files. No need to search or switch screens.",
      image: cardTabImg3,
      alt: "AI suggesting smart replies during live chat",
    },
    {
      tabName: "Support all file types and cloud drives",
      heading: "Support all file types and cloud drives",
      text: "Use any file type and connect cloud drives. Upload PDFs, DOCX, or text files. You can also connect Google Drive, OneDrive, or Confluence. Your content stays synced and easy to use.",
      image: cardTabImg4,
      alt: "AI knowledge base connected with cloud storage and multiple file types",
    },
  ];

  const adaptList = [
    {
      pointer: "Boost team productivity",
      desc: "Get instant answers inside your CRM and spend less time searching.",
      img: adaptImg1,
      alt: "Boost team productivity",
    },
    {
      pointer: "Keep messages consistent",
      desc: "Share the same, on-brand replies across teams with help from AI.",
      img: adaptImg2,
      alt: "Keep messages consistent",
    },
    {
      pointer: "Speed up onboarding and training",
      desc: "Use the AI to guide new team members with easy, self-serve info.",
      img: adaptImg3,
      alt: "Speed up onboarding and training",
    },
    {
      pointer: "Faster responses",
      desc: "Answer faster in chats and support tickets using AI-suggested replies.",
      img: adaptImg4,
      alt: "Faster responses",
    },
    {
      pointer: "24/7 support",
      desc: "Let both your team and customers get help 24/7—powered by generative AI in knowledge management.",
      img: adaptImg5,
      alt: "24/7 AI-powered support",
    },
  ];

  const benefits = [
    {
      title: "Trains on your content",
      desc: "The AI knowledge base learns from your files, manuals, and web links—not from random internet data.",
      icon: benefitIcon1,
    },
    {
      title: "No limits on growth",
      desc: "Add as many groups, users, and documents as you need. It grows with your team.",
      icon: benefitIcon2,
    },
    {
      title: "Built inside the CRM",
      desc: "Use AI-suggested replies in chats, emails, and tasks—no need to switch tools.",
      icon: benefitIcon3,
    },
    {
      title: "Works with WhatsApp, email, and web",
      desc: "Talk to customers on every channel from one shared inbox.",
      icon: benefitIcon4,
    },
    {
      title: "Smart workflows with AI help",
      desc: "Automate daily tasks, send follow-ups, and get helpful suggestions from AI-powered workflows.",
      icon: benefitIcon5,
    },
    {
      title: "Live support from agentic AI",
      desc: "Let AI assistants guide your team with tips, lead scores, and next steps—based on real-time context.",
      icon: benefitIcon6,
    },
  ];

  const tabContentData = [
    {
      tabContent: [
        {
          title: "Objection handling and pricing",
          content: "Let AI suggest replies based on your sales content.",
          alt: "AI CRM for Sales Teams",
        },
        {
          title: "Product info on demand",
          content: "View brochures, specs, and features right inside the CRM",
          alt: "AI CRM for Sales Teams",
        },
        {
          title: "Consistent messaging",
          content: "Help reps use the latest sales info from one place.",
          alt: "AI CRM for Sales Teams",
        },
        {
          title: "Faster quote generation",
          content:
            "Let reps quickly respond to pricing requests using pre-approved templates and data.",
          alt: "AI CRM for Sales Teams",
        },
      ],
      img: realWorldImg1,
      alt: "AI CRM for Sales Teams",
      subtitle:
        "Enable your sales reps to access accurate, context-aware information instantly. Reduce delays in communication and enhance productivity with intelligent support.",
    },
    {
      tabContent: [
        {
          title: "Quick FAQ replies",
          content:
            "Get auto-suggested answers for returns, refunds, and order tracking.",
          alt: "AI CRM for Support Teams",
        },
        {
          title: "Faster resolutions",
          content:
            "Agents get helpful tips from the AI while chatting with customers.",
          alt: "AI CRM for Support Teams",
        },
        {
          title: "Better escalation support",
          content: "Easily access SOPs and guides for handling tough cases.",
          alt: "AI CRM for Support Teams",
        },
        {
          title: "Lower ticket volume",
          content:
            "AI resolves common queries before they even reach your support agents.",
          alt: "AI CRM for Support Teams",
        },
      ],
      img: realWorldImg2,
      alt: "AI CRM for Support Teams",
      subtitle:
        "Help your support team reply faster with trusted answers from the AI knowledge base. This reduces tickets and improves first-response accuracy with AI-powered knowledge management.",
    },
    {
      tabContent: [
        {
          title: "Quick access to SOPs and policies",
          content:
            "Retrieve operational documents instantly—no need for email follow-ups.",
          alt: "AI CRM for Operations Teams",
        },
        {
          title: "Aligned workflows",
          content:
            "Ensure all departments follow standard procedures by utilizing shared knowledge groups.",
          alt: "AI CRM for Operations Teams",
        },
        {
          title: "Eliminate silos",
          content:
            "Make crucial process documents accessible to every relevant team member.",
          alt: "AI CRM for Operations Teams",
        },
        {
          title: "Error reduction",
          content:
            "Give teams reliable information to avoid missteps in routine tasks.",
          alt: "AI CRM for Operations Teams",
        },
      ],
      img: realWorldImg3,
      alt: "AI CRM for Operations Teams",
      subtitle:
        "Eliminate fragmented communication and manual searches. With an AI-powered knowledge base, teams can collaborate more effectively and work from a single source of truth.",
    },
    {
      tabContent: [
        {
          title: "Self-service onboarding",
          content:
            "Give new hires direct access to policies, FAQs, and role-specific material.",
          alt: "AI CRM for HR and Onboarding Teams",
        },
        {
          title: "Faster ramp-up",
          content:
            "Reduce time spent in training sessions and repeated queries to managers.",
          alt: "AI CRM for HR and Onboarding Teams",
        },
        {
          title: "Standardised experience",
          content:
            "Ensure consistency in learning through AI-based knowledge management.",
          alt: "AI CRM for HR and Onboarding Teams",
        },
        {
          title: "Ongoing learning support",
          content:
            "Use AI to guide employees beyond onboarding with role-based knowledge updates.",
          alt: "AI CRM for HR and Onboarding Teams",
        },
      ],
      img: realWorldImg4,
      alt: "AI CRM for HR and Onboarding Teams",
      subtitle:
        "Support new employees with round-the-clock access to company knowledge. Let AI take the lead in guiding them through processes, policies, and best practices.",
    },
  ];

  const faqs = [
    {
      question: "How does an AI knowledge base work?",
      answer:
        "It reads your documents and understands questions. Then it gives quick, accurate answers—no searching needed.",
    },
    {
      question: "What files can I add to the AI knowledge base?",
      answer:
        "You can upload text, PDFs, Word files, or links. It also connects with Google Drive, OneDrive, and Confluence.",
    },
    {
      question: "Can it help my team respond faster?",
      answer:
        "Yes! It can cut search time in half, solve problems quicker, and improve support quality by 35%.",
    },
    {
      question: "How is it better than a normal knowledge base?",
      answer:
        "A regular system stays the same. An AI knowledge base learns, updates answers, and understands what users mean.",
    },
    {
      question: "Is it good for training new team members?",
      answer:
        "Yes. It helps new hires find info fast. This can cut training time by 30%.",
    },
    {
      question: "Does it provide 24/7 support?",
      answer:
        "Yes. The AI-powered knowledge base gives help 24/7 through chat, email, or other tools.",
    },
    {
      question: "Is my data safe in an AI knowledge base?",
      answer:
        "Yes. Tools like Pepper Cloud use access rules and security to keep your content safe.",
    },
  ];

  return (
    <main>
      <SEO
        title={"AI Knowledge Base for CRM | Pepper Cloud"}
        pathname={
          "https://peppercloud.com/best-ai-crm-features/ai-knowledge-base-for-crm/"
        }
        keywords="AI knowledge base, ai-powered knowledge base, AI-based knowledge management, generative ai in knowledge management"
        description={
          " Boost productivity with Pepper Cloud’s AI knowledge base. Deliver instant answers and streamline support using AI-powered knowledge management."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "VideoObject",
            name: "AssistAI",
            description:
              "Harness the power of Pepper Cloud's AssistAI to simplify conversations, automate tasks, streamline workflows, and more. Save time, improve productivity, and make smarter sales decisions with the best AI CRM for your sales workflow.",
            thumbnailUrl: [
              "https://drive.google.com/file/d/11D38QAsWjwxtUae6YnwdP1Y__tusgmRF/view?usp=drive_link",
            ],
            uploadDate: "2024-12-02",
            contentUrl:
              "https://peppercloud.com/static/aiPageHeroSection-3907c41f7c08dfe21633f203852eebe2.mp4",
            publisher: {
              "@type": "Organization",
              name: "Pepper Cloud",
              logo: {
                "@type": "ImageObject",
                url: "https://d4.alternativeto.net/TylnV9uYJt3KRkoH7m9Qbm-T2kdjqV4X3JgKsTxbTUs/rs:fit:280:280:0/g:ce:0:0/exar:1/YWJzOi8vZGlzdC9pY29ucy9wZXBwZXItY2xvdWQtY3JtXzI0MzM4NS5wbmc.png",
                width: "",
                height: "",
              },
            },
            duration: "PT1M12S",
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "How does an AI knowledge base work?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "It reads your documents and understands questions. Then it gives quick, accurate answers—no searching needed.",
                },
              },
              {
                "@type": "Question",
                name: "What files can I add to the AI knowledge base?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can upload text, PDFs, Word files, or links. It also connects with Google Drive, OneDrive, and Confluence.",
                },
              },
              {
                "@type": "Question",
                name: "Can it help my team respond faster?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes! It can cut search time in half, solve problems quicker, and improve support quality by 35%.",
                },
              },
              {
                "@type": "Question",
                name: "How is it better than a normal knowledge base?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A regular system stays the same. An AI knowledge base learns, updates answers, and understands what users mean.",
                },
              },
              {
                "@type": "Question",
                name: "Is it good for training new team members?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. It helps new hires find info fast. This can cut training time by 30%.",
                },
              },
              {
                "@type": "Question",
                name: "Does it provide 24/7 support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. The AI-powered knowledge base gives help 24/7 through chat, email, or other tools.",
                },
              },
              {
                "@type": "Question",
                name: "Is my data safe in an AI knowledge base?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Tools like Pepper Cloud use access rules and security to keep your content safe.",
                },
              },
            ],
          },
        ]}
      />

      <section className={classes.commonHeroSection}>
        <section className={classes.heroSection}>
          <div className="container">
            <div className={classes.heroSectionContainer}>
              <motion.h1
                initial={{ opacity: 1, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="font-wix-semibold font-white font-64"
              >
                {" "}
                Empower your team with an AssistAI{" "}
                <span>
                  <LazyImage source={aiIcon} alt={"AssistAi - Ai crm"} />
                  knowledge base
                </span>
              </motion.h1>
              <motion.p
                initial={{ opacity: 1, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="font-white font-wix-regular font-20"
              >
                Boost efficiency with an AI knowledge base that delivers
                instant, contextual answers. Powered by generative AI, it
                transforms documents, links, and chats into smart, real-time
                responses.
              </motion.p>
              <Link
                to="/contact/"
                className="font-18 font-white font-wix-regular primaryButton"
              >
                Book a free demo
              </Link>
              <div className={classes.boxes}>
                <div className={classes.box}>
                  <img
                    src={heroIcon1}
                    alt="Pepper Cloud CRM analysing customer sentiment using AI"
                  />
                  <p className="font-18 font-wix-medium font-white">
                    Instant replies across CRM, chat & WhatsApp
                  </p>
                </div>
                <div className={classes.box}>
                  <img
                    src={heroIcon2}
                    alt="Customer sentiment trends across closed conversations in AI CRM"
                  />
                  <p className="font-18 font-wix-medium font-white">
                    Organizes content from files, links & cloud drives
                  </p>
                </div>
                <div className={classes.box}>
                  <img src={heroIcon3} alt="AI sentiment analysis dashboard" />
                  <p className="font-18 font-wix-medium font-white">
                    Learns continuously to improve response accuracy
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={classes.trustedSection}>
          <div className="container">
            <div className="trustedHeading">
              <motion.h3
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-24 font-white"
              >
                Trusted by leading businesses for outstanding efficiency
              </motion.h3>
            </div>
          </div>
          <Swiper
            className={classes.partnerSlider}
            slidesPerView="auto"
            spaceBetween={60}
            loop={true}
            speed={2000}
            modules={[Autoplay]}
            allowTouchMove={false}
            autoplay={{
              delay: 100,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
          >
            {partners.map((partner) => (
              <SwiperSlide className={classes.partnerSlide}>
                <img src={partner.icon} alt={partner.alt} />
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      </section>

      <section className={classes.cardsSection}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 color-black7"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              What makes our AI knowledge base powerful
            </motion.h2>
          </div>
          <ul id="cards">
            {capabilities.map((data, index) => (
              <li className="card" id={`card-${index + 1}`}>
                <div
                  className="card-content"
                  style={{
                    backgroundImage: `url(${data.backgroundImage})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="cardImg">
                    <img alt={data.alt} src={data.img} />
                  </div>
                  <div className="cardContentData">
                    <h3 className="cardHeading font-wix-medium">
                      {data.heading}
                    </h3>
                    <p className="cardDesciption">{data.desc}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className={classes.hoverCardSection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Why your team needs an AI knowledge base?
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 font-white"
            >
              Let your team focus on what matters. An AI-powered knowledge base
              gives quick answers from your documents, manuals, and links—right
              inside the CRM
            </motion.p>
          </div>
          <div className={classes.hoverCardContianer}>
            {hoverCardCard.map((card) => (
              <div className={classes.hoverCard}>
                <h3 className="font-64 font-white font-wix-bold">
                  {card.heading}
                </h3>
                <p className="font-18 font-white font-semibold">{card.text}</p>
              </div>
            ))}
          </div>
          <div className={classes.belowText}>
            <p className="font-12 font-wix-regular">
              * Statistics from multiple sources
            </p>
          </div>
        </div>
      </section>

      <section className={classes.cardTabsSection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Features of the{" "}
              <span>
                <LazyImage source={aiIcon2} alt={"AssistAi - Ai crm"} />
              </span>
              AI knowledge base intelligence
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 font-white"
            >
              The AI knowledge base helps your team work faster and better. It
              gives quick answers, keeps things accurate, and grows with your
              business. Whether you're helping a customer or closing a sale, it
              makes the job easier.
            </motion.p>
          </div>
          <div className={classes.cardTabsContainer}>
            <div className={classes.cardTabsSelectors}>
              {cardTabs.map((tab, i) => (
                <div
                  className={clsx(
                    classes.cardTabsSelector,
                    "font-18",
                    "font-wix-semibold",
                    cardTabSelector === i && "active",
                  )}
                  onClick={() => setCardTabSelector(i)}
                >
                  {tab.tabName}
                </div>
              ))}
            </div>
            {cardTabs.map(
              (tab, i) =>
                cardTabSelector === i && (
                  <div className={classes.cardTab}>
                    <div className={classes.cardTabLeft}>
                      <p className="font-24 font-wix-semibold font-white">
                        {tab.tabName}
                      </p>
                      <p className="font-18 font-wix-regular font-white">
                        {tab.text}
                      </p>
                    </div>
                    <div className={classes.cardTabRight}>
                      <LazyImage
                        source={tab.image}
                        height={"100%"}
                        width={"100%"}
                        alt={tab.alt}
                      />
                    </div>
                  </div>
                ),
            )}
          </div>
        </div>
      </section>

      <section className={classes.detailSection}>
        <div className="container">
          <div className={classes.detailCard}>
            <div className={classes.detailCardRight}>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-20 font-white"
              >
                AssistAI
              </motion.p>
              <motion.h2
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-56 font-white"
              >
                One system, endless smart actions
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 font-white"
              >
                From sentiment tagging to workflow triggers, let AI handle the
                repetitive stuff. You focus on decisions — your CRM takes care
                of the data.
              </motion.p>
            </div>
            <div className={classes.detailCardLeft}>
              <LazyImage
                width={"100%"}
                source={detailImg2}
                alt="AI CRM for marketing teams"
              />
            </div>
          </div>
        </div>
      </section>

      <section className={classes.salesCrmCarousel}>
        <div className="container">
          <div className="header-section">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Benefits of using the AI knowledge base
            </motion.h2>
            <motion.p
              className="font-wix-regular font-18 color-black2"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              A smart AI knowledge base helps your team save time, give better
              answers, and stay consistent. With AI-powered knowledge
              management, your team can work faster and support customers with
              ease.
            </motion.p>
          </div>
        </div>
        <Swiper
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1,
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              slidesPerGroup: 1,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 4,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
          }}
          className={classes.adaptSlider}
          grabCursor={true}
          loop={true}
          modules={[Autoplay]}
          speed={5000}
          slidesPerView={"auto"}
          // centeredSlides={true}
          spaceBetween={30}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  // alt={point.card.alt}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold lineHeight-1">
                  {point.pointer}
                </p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section className={classes.benefitSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Why Pepper Cloud is the best AI CRM
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-18 font-white"
            >
              Pepper Cloud uses the power of Generative AI, Assistive AI, and
              Conversational AI to build a smart CRM. It helps your team respond
              faster, work better, and stay consistent.
            </motion.p>
          </div>
          <div className={classes.benefitContainer}>
            {benefits.map((benefit) => (
              <div className={classes.benefitBox}>
                <img
                  src={benefit.icon}
                  alt="Customer support automation tool"
                />
                <p className="font-wix-semibold font-20 font-white">
                  {benefit.title}
                </p>
                <p className="font-wix-regular font-16 font-white">
                  {benefit.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className={classes.tabsSection}>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow={true} background={true} />
        </div>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Applications & use cases of the AI knowledge base
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 color-black2"
            >
              The AI knowledge base is designed to support every team that
              depends on fast, reliable information. From sales and support to
              operations and HR, it helps reduce delays, improve accuracy, and
              drive better results—powered by intelligent, real-time responses.
            </motion.p>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  "color-black4",
                  activeRealWorld === 0 && "active",
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                Sales teams
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  "color-black4",
                  activeRealWorld === 1 && "active",
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Customer support
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  "color-black4",
                  activeRealWorld === 2 && "active",
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Operations teams
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  "color-black4",
                  activeRealWorld === 3 && "active",
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Onboarding & HR
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-black2"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.tabListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.tabListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.tabIcon}
                              alt={item.alt}
                            />
                            <div className={classes.tabListItemContent}>
                              <p className="font-wix-semibold font-18 color-black2">
                                {item.title}:
                              </p>
                              <p className="font-wix-regular font-18 color-black3">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  ),
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                    // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  ),
              )}
            </div>
          </div>
        </div>
      </section>

      <TestimonialSlider
        desc={
          "Discover how businesses are transforming customer engagement with Pepper Cloud."
        }
        heading={"Real stories. Real results."}
        noButton={true}
      />

      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          heading={"Frequently asked questions -AI knowledge base"}
          faqs={faqs}
        />
      </div>

      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Boost team productivity with Pepper Cloud’s AI knowledge base
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Book a demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AiKnowledgeBaseForCrm;
